export const typeSafeObjectKeys = <Key extends string | number, Value>(
  object: Record<Key, Value>
): Key[] => {
  const entries: Key[] = [];
  for (const key in object) {
    entries.push(key);
  }
  return entries;
};
